var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container mt-4"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col col-md-6 col-lg-4"},[_c('h4',[_vm._v("Login")]),_c('Login',{on:{"logued":_vm.loguedHandler}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }